"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _IndicatorButton = _interopRequireDefault(require("../IndicatorButton"));
var _icons = require("../../icons");
const GatsbyIndicatorButton = () => {
  const buttonProps = {
    testId: `gatsby`,
    icon: _icons.gatsbyIcon,
    clickable: false
  };
  return /*#__PURE__*/_react.default.createElement(_IndicatorButton.default, buttonProps);
};
var _default = GatsbyIndicatorButton;
exports.default = _default;